import Military from 'assets/images/psp/psplinkscard/military.svg';
import Self from 'assets/images/psp/psplinkscard/Self.svg';
import Business from 'assets/images/psp/psplinkscard/Business.svg';
import College from 'assets/images/psp/psplinkscard/College.svg';
import Truck from 'assets/images/psp/psplinkscard/Truck.svg';
import ClimateControl from 'assets/images/icons/psp/CC.svg';
import Portable from 'assets/images/psp/psplinkscard/Portable.svg';
import Car from 'assets/images/psp/psplinkscard/Car.svg';
import RV from 'assets/images/psp/psplinkscard/RV.svg';
import Boat from 'assets/images/psp/psplinkscard/Boat.svg';
import Motorcycle from 'assets/images/psp/psplinkscard/motorcycle.svg';
import Kayak from 'assets/images/psp/psplinkscard/kayak.svg';
import TwentyFourHour from 'assets/images/psp/psplinkscard/24-hour.svg';
import DriveUp from 'assets/images/psp/psplinkscard/drive-up.svg';
import ATV from 'assets/images/psp/psplinkscard/atv.svg';
import Bicycle from 'assets/images/psp/psplinkscard/bicycle.svg';
import DirtBike from 'assets/images/psp/psplinkscard/dirtbike.svg';
import GolfCart from 'assets/images/psp/psplinkscard/golf-cart.svg';
import JetSki from 'assets/images/psp/psplinkscard/jetski.svg';
import Electricity from 'assets/images/psp/psplinkscard/electricity.svg';
import Wine from 'assets/images/psp/psplinkscard/wine.svg';
import Mini from 'assets/images/psp/psplinkscard/mini.svg';
import FiveByFive from 'assets/images/psp/psplinkscard/5x5.svg';
import TenByTwenty from 'assets/images/psp/psplinkscard/10x20.svg';
import FiveByTen from 'assets/images/psp/psplinkscard/5x10.svg';
import Locker from 'assets/images/psp/psplinkscard/Locker.svg';
// import Cubesmart from 'assets/images/psp/psplinkscard/cubesmart.svg';
import Vehicle from 'assets/images/psp/psplinkscard/vehicle.svg';
import TenByTen from 'assets/images/sgp/10x15/10x10.svg';
import TenByFifteen from 'assets/images/psp/psplinkscard/10x15.svg';
import TenByTwentyFive from 'assets/images/psp/psplinkscard/10x25.svg';
import TenByThirty from 'assets/images/psp/psplinkscard/10x30.svg';
import FiveByFifteen from 'assets/images/psp/psplinkscard/5x15.svg';
export const getPSPLinksData = (links) => {
	return links.map((link) => linkData[link]);
};

const linkData = {
	Military: {
		title: 'Military Storage',
		image: Military,
		link: '/military-storage.html',
	},
	SelfStorage: {
		title: 'Self Storage',
		image: Self,
		link: '/storage-101.html',
	},
	Business: {
		title: 'Business Storage',
		image: Business,
		link: '/business-storage.html',
	},
	College: {
		title: 'College Student Storage',
		image: College,
		link: '/college-storage.html',
	},
	Truck: {
		title: 'Truck Storage',
		image: Truck,
		link: '/truck-storage.html',
	},
	ClimateControl: {
		title: 'Climate-Controlled Storage',
		image: ClimateControl,
		link: '/climate-controlled-storage.html',
	},
	Vehicle: {
		title: 'Vehicle Storage',
		image: Vehicle,
		link: '/vehicle-storage.html',
	},
	Portable: {
		title: 'Portable Storage',
		image: Portable,
		link: '/portable-storage.html',
	},
	Electricity: {
		title: 'Storage With Electricity',
		image: Electricity,
		link: '/storage-with-electricity.html',
	},
	Car: {
		title: 'Car Storage',
		image: Car,
		link: '/car-storage.html',
	},
	DriveUp: {
		title: 'Drive-Up Storage',
		image: DriveUp,
		link: '/drive-up-storage.html',
	},
	RV: {
		title: 'RV Storage',
		image: RV,
		link: '/rv-storage.html',
	},
	Boat: {
		title: 'Boat Storage',
		image: Boat,
		link: '/boat-storage.html',
	},
	Motorcycle: {
		title: 'Motorcycle Storage',
		image: Motorcycle,
		link: '/motorcycle-storage.html',
	},
	Kayak: {
		title: 'Kayak Storage',
		image: Kayak,
		link: '/kayak-storage.html',
	},
	'24Hour': {
		title: '24-Hour Storage',
		image: TwentyFourHour,
		link: '/24-hour-storage.html',
	},
	Mini: {
		title: 'Mini Storage',
		image: Mini,
		link: '/storage-unit-size-guide/mini-storage.html',
	},
	'5x5': {
		title: '5x5 Storage',
		image: FiveByFive,
		link: '/storage-unit-size-guide/5x5-storage-unit.html',
	},
	'10x20': {
		title: '10x20 Storage',
		image: TenByTwenty,
		link: '/storage-unit-size-guide/10x20-storage-unit.html',
	},
	ATV: {
		title: 'ATV Storage',
		image: ATV,
		link: '/atv-storage.html',
	},
	Wine: {
		title: 'Wine Storage',
		image: Wine,
		link: '/wine-storage.html',
	},
	Bicycle: {
		title: 'Bicycle Storage',
		image: Bicycle,
		link: '/bicycle-storage.html',
	},
	DirtBike: {
		title: 'Dirt Bike Storage',
		image: DirtBike,
		link: '/dirt-bike-storage.html',
	},
	GolfCart: {
		title: 'Golf Cart Storage',
		image: GolfCart,
		link: '/golf-cart-storage.html',
	},
	JetSki: {
		title: 'Jet Ski Storage',
		image: JetSki,
		link: '/jet-ski-storage.html',
	},
	'5x10': {
		title: '5x10 Storage',
		image: FiveByTen,
		link: '/storage-unit-size-guide/5x10-storage-unit.html',
	},
	StorageLockers: {
		title: 'Storage Lockers',
		image: Locker,
		link: '/storage-unit-size-guide/storage-lockers.html',
	},
	'10x10': {
		title: '10x10 Storage',
		image: TenByTen,
		link: '/storage-unit-size-guide/10x10-storage-unit.html',
	},
	'10x15': {
		title: '10x15 Storage',
		image: TenByFifteen,
		link: '/storage-unit-size-guide/10x15-storage-unit.html',
	},
	'10x25': {
		title: '10x25 Storage',
		image: TenByTwentyFive,
		link: '/storage-unit-size-guide/10x25-storage-unit.html',
	},
	'10x30': {
		title: '10x30 Storage',
		image: TenByThirty,
		link: '/storage-unit-size-guide/10x30-storage-unit.html',
	},
	'5x15': {
		title: '5x15 Storage',
		image: FiveByFifteen,
		link: '/storage-unit-size-guide/5x15-storage-unit.html',
	},
};
